export function getErrorFromResponse(response) {
  if (response?.error?.networkError) {
    return (
      response?.error?.networkError?.result?.errors
        ?.map((e) => e?.message)
        ?.filter(Boolean)
        ?.join('; ') || null
    );
  }
  if (response?.error?.message) {
    return response?.error?.message;
  }
}

export function remapData(result, dataKey) {
  const errorMessages = getErrorFromResponse(result);

  return {
    ...result,
    data: result.data?.[dataKey],
    error: errorMessages,
  };
}

export function remapResponseHandler(mutateFunc, dataKey) {
  return async (data) => {
    const result = await mutateFunc({ variables: { data } });

    return remapData(result, dataKey);
  };
}
